module.exports = __webpack_public_path__ + "static/img/logo.3b800357.svg";